(function () {
    'use strict';

    function FileUploadController($scope, $attrs, $element, FileUtilCustom) {
//
        var $ctrl = this;
        $ctrl.myFile = '';
        $ctrl.file = '';
        $ctrl.openFile = openFile;
        $ctrl.prefixUrl = '';
        $ctrl.removeFile = removeFile;
        $ctrl.downloadFile = downloadFile;
        $ctrl.isUploading = false;
        $ctrl.randomId = (Math.random() + 1).toString(36).substring(7);

        // $ctrl.filePath = '';
        // $ctrl.myCroppedImage='';
        $ctrl.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0];
            $ctrl.file = file;
            var reader = new FileReader();
            reader.onload = function (evt) {
                uploadToServer();
                // $scope.$apply(function($scope){
                //     $ctrl.myFile=evt.target.result;
                //
                // });
            };
            reader.readAsDataURL(file);
        };


        // angular.element(document.querySelectorAll('#fileInput')).on('change',handleFileSelect);


        function uploadToServer() {
            if (!$ctrl.file)
                return;
            var fd = new FormData();
            //Take the first selected file
            fd.append("file", $ctrl.file);
            $ctrl.isUploading = true;

            FileUtilCustom.supplierFileUploadToServer().upload(fd, onSaveSuccess, onSaveError);


        }


        function onSaveError() {
            $ctrl.isUploading = false;
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:fileUtilUpdate', result);

            $ctrl.isUploading = false;
            $ctrl.file = result;
            $ctrl.fileName = result.fileName;

        }

        function openFile() {
            if (!$ctrl.fileName)
                return;
            if (!$ctrl.prefixUrl) {
                FileUtilCustom.getFileUrlPrefix().query().$promise.then(function (result) {
                    $ctrl.prefixUrl = result.filePrefix;
                    var link = $ctrl.prefixUrl + '\\' + $ctrl.fileName;
                    window.open(link, '_blank');
                });


            } else {
                var link = $ctrl.prefixUrl + '\\' + $ctrl.fileName;
                window.open(link, '_blank');
            }
        }

        function downloadFile() {
            if (!$ctrl.fileName)
                return;

            FileUtilCustom.getSupplierFileDownloadLink($ctrl.fileName).query().$promise.then(function (result) {
                window.open(result.fileLink, '_blank');
            });
        }

        function removeFile() {
            $ctrl.file = null;
            $ctrl.fileName = null;
        }

        // $scope.$watch('$ctrl.fileName', function (fileName) {
        //
        //
        // })

    }

    var FileUpload = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/file-upload/eyeson.file-upload.html',
        controller: FileUploadController,
        bindings:
            {
                fileName: '='
            }

    };

    angular
        .module('tikonApp')
        .component('eoFileUpload', FileUpload)

    FileUploadController.$inject = ['$scope', '$attrs', '$element', 'FileUtilCustom'];


})();

